module.exports = __webpack_public_path__ + "static/media/openlinealogo.431cc9bb.png";